import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card as MuiCard } from '@mui/material';
import styled from 'styled-components';

export const Card = styled(MuiCard)`
  background-color: #eee;
  border-radius: 20px;
  flex: 1;
  min-width: 300px;
`;

export const CardTitle = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-weight: bold;
`;

export const InfoIcon = styled(FontAwesomeIcon)`
  &:hover {
    cursor: help;
  }
`;

export const AmountContainer = styled.div`
  margin-top: 16px;
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Amount = styled.p`
  margin: 0;
`;
